import { getSavedJobFilters } from '@/api';
import { useQuery } from './use-query';
export var useSavedJobFilters = function (_a) {
    var _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    var _c = useQuery({
        queryFn: getSavedJobFilters,
        config: { enabled: enabled },
    }), savedFilters = _c.data, isLoadingSavedFilters = _c.isLoading, refetchSaveJobFilters = _c.refetch;
    return {
        savedFilters: savedFilters || [],
        isLoadingSavedFilters: isLoadingSavedFilters,
        refetchSaveJobFilters: refetchSaveJobFilters,
    };
};
